export const config = {
  apiKey: 'AIzaSyBjxEV8tfRbF8PscABb8iwHBH1P7mPc9bE',
  // authDomain: 'television-guide.firebaseapp.com',
  authDomain: 'auth.optv.nu',
  databaseURL: 'https://television-guide.firebaseio.com',
  projectId: 'television-guide',
  storageBucket: 'television-guide.appspot.com',
  messagingSenderId: '191430651239'
}



// WEBPACK FOOTER //
// ./src/firebaseConfig.js